import api from "@/config/apiConfig"

class ChatImportController {

  async historyStatus ( channelId ) {
    try {
      const response = await api.get( `/channel/${ channelId }/import/history-status` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ChatImportController.historyStatus: ", error );
      throw error;
    }
  }

  async historyConfig ( channelId, config ) {
    try {
      const response = await api.post( `/channel/${ channelId }/import/history-config`, config );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ChatImportController.historyConfig: ", error );
      throw error;
    }
  }

  // range: { days } ou { from, to } (YYYY-MM-DD)
  async preview ( channelId, range ) {
    try {
      const response = await api.post( `/channel/${ channelId }/import/preview`, range );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ChatImportController.preview: ", error );
      throw error;
    }
  }

  async contacts ( channelId, search ) {
    try {
      const response = await api.get( `/channel/${ channelId }/import/contacts`, { params: { search } } );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ChatImportController.contacts: ", error );
      throw error;
    }
  }

  async compare ( channelId, remoteJid, range ) {
    try {
      const response = await api.post( `/channel/${ channelId }/import/compare`, { remoteJid, ...range } );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ChatImportController.compare: ", error );
      throw error;
    }
  }

  async confirm ( channelId, payload ) {
    try {
      const response = await api.post( `/channel/${ channelId }/import/confirm`, payload );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ChatImportController.confirm: ", error );
      throw error;
    }
  }
}

export default new ChatImportController()
